export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7644.e1e4b380.jpg";